var popSignup = angular.module("pop.signup",[]);

popSignup.directive('popSignup', function(popSignup) {
	return {
		restrict: 'E',
		templateUrl: '/js/app/views/signup-directive.html',
		link: function(scope,el,attr) {
            el.addClass('pop-signup-portable');
			popSignup.init(scope, attr.open);
		}
	}
});

popDirectives.factory("popSignup", function($rootScope,$location, validationHelper, $anchorScroll, domainService, $route, $http){
	return {
		init: function(scope, openflag) {
			var $scope = scope;
			var $nextbtn = $('#nextbutton'),
				$mainError = $('#main-error');

			$scope.steps = ['/register',
							'/register/contact',
							'/register/starterpage',
							'/register/method',
							'/register/cell',
							'/register/email',
							'/register/payment',
							'/register/verify',
							'/register/complete'
							];

			$rootScope.currentStep = 0;
			//$scope.istransitioning = false;
			$scope.slide = '';

			$rootScope.showTitle = '';
			$rootScope.showSubtitle = '';

			$rootScope.formData = {};
			$rootScope.validCell = false;
			$rootScope.validPin = false;
			$rootScope.validEmailInfo = false;
			$rootScope.ajax = false;
			$rootScope.showAlerts = false;
			$rootScope.showSignup = false;

			$rootScope.showSignupForm = POP.showSignup;
			$rootScope.blockedIP = POP.blockedIP;

			$rootScope.suggestions = [];

			$rootScope.selectedDomain = null;
			$rootScope.selectedEmail = "atmail";
			$rootScope.selectedStarterPage = null;

			$rootScope.formData.cell_countrycode = "US"
			$rootScope.formData.cell_countrycode_numeric = 1;
			$rootScope.cellErrors = false;
			$rootScope.validCell = false;

			$rootScope.anytld = getTlds();
			$rootScope.currentBundle = "startup";

			$rootScope.formData.comm_pref = 'cell';

			$rootScope.getSubtitle = function(){
				var domains = '.' + $rootScope.anytld.join(', .').toUpperCase();
				var st = 'This is where you pick your free '+ domains +' domain name';
				//match comma not followed by another comma
				return st.replace(/,(?![\s\S]*,)/g, ' or ');
			};

		
			/*
			 * global method wrapper for registration validation service call
			 */
			$rootScope.validateVerify = function(needtoverify) {
				$rootScope.showAlerts = false;

				$rootScope.formData.trial = $rootScope.currentBundle == "startup";

				//perform overall verification, if successful then route to verify
				validationHelper.validate($rootScope, !needtoverify ? true : false).then(function(resp){
					if(resp.code === 200)
					{
						if(needtoverify === true)
						{
							$location.url('/register/verify');
						} else {
							$rootScope.success = true;
						}
					} else {
						POP.Message.response($mainError,resp,false,false);
						$rootScope.showAlerts = true;
					}

				}).catch(function(e){
					//display errors here
				});
			}

			/*
			 * global method wrapper for registration pin validation service call
			 */
			$rootScope.validatePin = function(redirect) {
				$rootScope.showAlerts = false;
				$rootScope.success = false;

				if(redirect === true)
				{
					$rootScope.formData.already_verified = true;
				}

				validationHelper.validatePin($rootScope, false).then(function(resp){
					if(resp.code != 200)
					{
						POP.Message.response($mainError,resp,false,false);
						$rootScope.showAlerts = true;
					} else {
						$rootScope.success = true;
						
						if (!redirect)
						{
							if($rootScope.modalServiceSignup === true)
							{
								$rootScope.formData.tmp_user_id = resp.data.tmp_user_id;
								//straight to fake percolator
								$rootScope.validatePin(true);
							} else {
								$rootScope.formData.tmp_user_id = resp.data.tmp_user_id;
								$location.url('/register/complete');
							}
						}
					}
				});
			}

			/*
			 * global method for simple registration
			 */
			$rootScope.simpleRegistration = function() {
				$rootScope.showAlerts = false;
				$rootScope.success = false;
				
				var data = {
					domain : '',
					firstname : '',
					lastname : '',
					comm_email : '',
					coupon_code : '',
					comm_pref : 'email',
					confirm_terms : 1,
					username : "empty"
				}

				domainService.simpleRegisterDomain(data);
			}

			/*
			 * utility method to find if this is a .co domain TODO: place this somewhere else
			 */
			$rootScope.isdotCo = function(domain) {
				if(typeof domain != 'undefined' && domain != null)
					return domain.match(/\.co$/g) != null;
				else
					return false;
			}

			$rootScope.checkForIpBlock = function(force) {
				if (POP.ipblocked === true || force === true) {
					window.location.href = '/notify';
				}

				return false;
			};

			/*
			 * switch between signup modal / home content
			 */
			 /*
			 * switched this to Rootscope to test with new page layout
			 */
			$rootScope.toggleSignup = function(option,wipedomain) {

				if(option ==='notify') {
					$rootScope.checkForIpBlock(true);
					return;
				}

				$rootScope.showAlerts = false;
				
				$rootScope.suggestions = [];
				$rootScope.available = false;
				$rootScope.domainError = false;

				$rootScope.showSignup = $rootScope.showSignup === true ? false : true;
				$rootScope.selectedDomain = null;
				$rootScope.formData.domain = (wipedomain === false || (getQS('d') != null && getQS('d').length > 0)) ? $rootScope.formData.domain : '';
				
				$location.hash('top');
				$anchorScroll();

				if(option==='show')
				{
					$scope.showSignup = true;
					$location.url('/');
					return;
				}
				if(option==='hide')
				{
					$scope.showSignup = false;
					$location.url('/');
					$('footer').show();
					$('#nav-wrap').show();
					$('#habla_beta_container_do_not_rely_on_div_classes_or_names').show();
				
					if( isMobile.any() ){ $('.main-site-header').show(); }
					$("#wrap").removeClass('skybg');
					return;
				}

				//hate to do this...  Also removing tab switcher when search is open.
				$('footer').toggle();
				$('#nav-wrap').toggle();
				$('#habla_beta_container_do_not_rely_on_div_classes_or_names').toggle();
				
				if( isMobile.any() ){ $('.main-site-header').toggle(); }
				$("#wrap").toggleClass('skybg');
				
				$location.url($rootScope.showSignup ? '/register' : '/');

                                if (typeof _kmq != 'undefined') {
    				_kmq.push(['set', {'Signup-Bundle':$rootScope.currentBundle}]);
                                }
			}

			/*
			 * check if query string ?d exists and turn on signup modal
			 */
			if (getQS('d')) {
				$rootScope.checkForIpBlock();
				$rootScope.formData.domain = getQS('d') === true ? "" : getQS('d');
			}
			
			if(parseInt(getQS('o')) === 1 && POP.showSignup != false)
			{
				$rootScope.toggleSignup(1, false);
			}
			
			if(openflag === 'true')
			{
				$rootScope.toggleSignup('show');
			}	

			/*
			 * currentstep validation method, it checks if corresponding form is valid TODO: refactor steps array to include each step's validation criteria
			 */
			$scope.isCurrentStepValid = function() {
				switch ($rootScope.currentStep) {
					case 0:
						return $rootScope.selectedDomain != null;
						break;
					case 1:
						if ($rootScope.modalServiceSignup === true) {
							return $rootScope.validUserPass;
						} else {
							return $rootScope.validEmailInfo;
						}
						break;
					case 2:
						return $rootScope.selectedStarterPage = true;
						break;
					case 6:
						return $rootScope.paymentValidation && $rootScope.formData.confirm_terms === true;
						break;
					case 4:
						return $rootScope.validCell && $rootScope.formData.confirm_terms === true;
						break;
					case 5:
						return $rootScope.validEmail && $rootScope.formData.confirm_terms === true;
						break;
					case 8:
						return $rootScope.completeValid;
						break;
				}
			}

			$scope.validateEmail = function(){
				$rootScope.ajax = true;
				$rootScope.showAlerts = false;

				$http({
					method: 'POST',
					url: POP.apiBaseUrl + '/register/validate/login_name',
					data: JSON.stringify({email:$rootScope.formData.email}),
				}).success(function(resp){
					$rootScope.ajax = false;
					
					if (resp.code === 200) {
						$location.url('/register/cell');
					} else {
						// show message
						POP.Message.response($mainError, resp, false, false);
						$rootScope.showAlerts = true;
					}
				});
			}
			/*
			 * handles next step navigation, it contains a few logical checks i'd rather move somewhere else
			 */
			$rootScope.nextStep = function(skip) {
				$rootScope.checkForIpBlock();

				// just in case its called directly
				if ($scope.isCurrentStepValid()) {
					var trackId = $rootScope.currentStep + 1;
					switch ($rootScope.currentStep) {
						case 3:
							trackid = '4-phone';
						break;
						case 4:
							trackId = '5-phone';
						break;
						case 5:
							trackId = '5-email';
						break;
						case 6:
							trackId = '4-payment';
						break;
						case 7:
							trackId = '6-verified';
						break;
						case 8:
							trackId = '7-complete';
						break;
					}

					$('.step-' + trackId).trigger('click');

					// update step from 1 to 3
					if ($rootScope.currentStep == 1) {
						$rootScope.currentStep = 3;
					}
					
					// if this is part of a app store signup
					if ($rootScope.modalServiceSignup === true) {
						switch ($rootScope.currentStep) {
							case 0:
								$location.url('/register/userpass');
								break;
							case 3:
								$scope.validateEmail();
								break;
						}
					} else {
						// trigger update of view with url update
						$location.url($scope.steps[$rootScope.currentStep + 1]);
					}
				} else {
					void 0;
				}
			}

			/*
			 * handles previous step navigation, contains some logical checks for registration method
			 */
			$scope.prevStep = function(){
				$rootScope.checkForIpBlock();

				switch ($rootScope.currentStep) {
					case 4:
					case 5:
						if ($rootScope.modalServiceSignup === true) {
							$location.url('/register/userpass');
						} else {
							$location.url('/register/contact');
						}
						break;
					case 6:
						$location.url('/register/contact');
						break;
					case 7:
						if ($rootScope.showResendMessage == true) {
							$location.url('/register/cell');
						}
						break;
					default:
						$location.url($scope.steps[$rootScope.currentStep - 1]);
						break;
				}

			}

			/*
			 * routechangestart event listener, this is where we determine the slide direction and change the class accordingly
			 */
			$scope.$on('$routeChangeStart', function(e) {
				var next = $scope.steps.indexOf($location.path());

				$scope.slide = $rootScope.currentStep > next ? 'slide-right' : 'slide-left';

				if($location.path() == '/register/userpass')
				{
					$rootScope.currentStep = 1;
				} else {
					$rootScope.currentStep = next;
				}

				//$scope.istransitioning = true;
			});

			/*
			 * viewcontentloaded event listener, we remove duplicate views, just in case.
			 */
			$scope.$on('$viewContentLoaded', function(e) {

				//$scope.istransitioning = false;
				
				// Scroll viewcontainer to top if visible and step changed
				if( $('.viewcontainer').is(":visible") ){
					if( isMobile.any() ){ 
						POP.scrollTo('.start-over-btn', true, false, 75);	
						// console.log('POP Scroll - mobile fired');	
					} else {
						POP.scrollTo('.start-over-btn', true, false, 200);	
						// console.log('POP Scroll - desktop fired');	
					}
					
				}
			});

			/*
			 * hijack enter key event to NOT submit form
			 */
			$('form').bind('keydown', function(evt){
				var evt = (evt) ? evt : ((event) ? event : null);
				if (evt.keyCode == 13) {
					return false;
				}
			});
				}

			}
});
